import React from 'react';
import './ServiceSingle.css';

import { Lightbox, PageTitle, SidebarHeading, Faqs } from '../../../components';
import { services } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaTaxi, FaCheck } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';



const ServiceSingle = () => { 

  const location = useLocation();  
  const serviceSingle = location.state; 

  const features = serviceSingle.features;
  const process = serviceSingle.process;


  return (
    <>
      {/* Page Title */}
      <PageTitle title={'service single'} page={'service single'} />

      <section className='service-single page-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all services'} />

            <div className='box-container'>
              {services.map(service => {
                return  (                
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Services/' + service.title,
                  }}
                  location = {{service}}
                  state= {service}
                  key={service.id}
                  className='item'><span><div className='icon'>{renderIcon(service.title)}</div>{service.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

            </div>

        </div>

        <div className='service-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={serviceSingle.image} alt={serviceSingle.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{serviceSingle.title}</h3>

            {/* Service Content */}
            {serviceSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Service Image gallery */}
          <Lightbox images={serviceSingle.gallery} />

          {/* Section for service benefits */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>key features</h3>

            <p>{features.intro}</p>

            {/* List of service benefits */}
            <ul>
              {features.list.map((feature, index) => {
                return <li key={index}><FaCheck className='icon' />{feature}</li>
              })}
            </ul>

          </div>

          {/* Section for service process */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>service process</h3>

            <p>{process.intro}</p>

            {/* List of service benefits */}
            <ul>
              {process.list.map((step, index) => {
                return <li key={index}><FaTaxi className='icon' />{step}</li>
              })}
            </ul>

          </div>

          {/* Section for frequently asked questions */}
          <div className='service-faqs sub-section'>

            <h3 className='sub-heading'>frequently asked questions</h3>

            {/* Faq Accordion container */}
            <Faqs faqs={serviceSingle.faqs} />

          </div>
        
        </div> 

      </section> 
    </> 
  );
}

export default ServiceSingle;